import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  StatementMessageModel,
} from '../../core/interfaces/statement-messaging-run.model';

@Injectable({
  providedIn: 'root',
})
export class SelectedMessageDetailService {
  // BehaviorSubject - Always has a value (null initially)
  private selectedMessageSubject = new BehaviorSubject<
    StatementMessageModel | null
  >(null);

  // Public observable for components to subscribe
  public selectedMessage$: Observable<
    StatementMessageModel | null
  > = this.selectedMessageSubject.asObservable();

  /**
   * Get currently selected message (synchronous)
   */
  getSelectedMessage(): StatementMessageModel | null {
    return this.selectedMessageSubject.value;
  }

  /**
   * Set selected message
   */
  selectMessage(message: StatementMessageModel | null): void {
    this.selectedMessageSubject.next(message);
  }

  /**
   * Clear selection
   */
  clearSelection(): void {
    this.selectedMessageSubject.next(null);
  }

  /**
   * Check if a message is currently selected
   */
  hasSelection(): boolean {
    return this.selectedMessageSubject.value !== null;
  }

  /**
   * Check if specific message is selected
   */
  isMessageSelected(messageId: string): boolean {
    const current = this.selectedMessageSubject.value;
    return current?.messageId === messageId;
  }
}
